import React from "react";
import { ChevronRight } from "lucide-react";

export default function Versao1013() {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-black mt-8">
        Histórico – Versão 1.0.13
      </h2>

      <ul className="space-y-4 text-black text-base leading-relaxed">
        <li>
          <strong>📊 Dashboard de Gráficos:</strong>
          <p className="ml-4">
            Novo painel com gráficos interativos para melhor visualização das informações em tempo real.
          </p>
          <ul className="list-disc list-inside ml-6 space-y-1">
            <li>Gráfico de chamados finalizados por cliente.</li>
            <li>Relatório de registros por usuários.</li>
            <li>Tabela dos clientes que mais pedem chamados.</li>
            <li>Gráfico de tipos de serviços mais utilizados.</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}